
    var riot = require('riot')
    
riot.tag2('thermometer', '<div class="row"></div>', '', '', function(opts) {
});
riot.tag2('thermometer-comments', '<div if="{!opts.dashboard}"> <h3>Customer Satisfaction</h3> <div class="dl_testimonials"> <div each="{comment in comments}" class="item indexitem"><small>{comment.date}</small><img riot-src="/images/assets/thermometer/{comment.icon}" width="40" style="float:left;margin-right:10px"> <div class="text"> <p>{comment.text}</p> </div> </div> </div> </div> <div if="{opts.dashboard}"> <div class="dashboard-box"> <h4>Client Quotes</h4> <div class="inner"> <div class="dl_testimonials dashboard-comments"> <div each="{comment in comments}" class="item"><small>{comment.date}</small><img riot-src="/images/assets/thermometer/{comment.icon}" width="40" style="float:left;margin-right:10px"> <div class="text"> <p>{comment.text}</p> </div> </div> </div> </div> </div> </div>', '', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/therm/comments', true);

this.comments = [];

this.icons = ["", "gold-1.jpg", "green-1.jpg", "amber-1.jpg", "red-1.jpg"];

this.max = 3;

if (this.opts.dashboard) {
  this.max = 10;
}

this.on('mount', (function(_this) {
  return function() {
    return api.get(function(data) {
      return _this.onload(data);
    });
  };
})(this));

this.onload = (function(_this) {
  return function(data) {
    var counter;
    counter = 0;
    data.comment.forEach(function(comment) {
      var containsemail, text;
      if (counter < _this.max) {
        containsemail = comment.comment.search(/([^.@\s]+)(\.[^.@\s]+)*@([^.@\s]+\.)+([^.@\s]+)/);
        if (comment.temperature_id < 3 && comment.comment.length > 3 && containsemail < 0) {
          text = _this.shorten('<p>' + comment.comment + '</p>', 150);
          if (comment.comment.length > 150) {
            text = text + '...';
          }
          _this.comments.push({
            text: text,
            date: _this.formatDate(comment.created_date),
            icon: _this.icons[comment.temperature_id]
          });
          return counter++;
        }
      }
    });
    return _this.update();
  };
})(this);

this.formatDate = function(date) {
  var datenow, datethen, diff, oneday, onehour, suffix;
  onehour = parseInt(3600 * 1000);
  oneday = parseInt(24 * onehour);
  datenow = new Date();
  datethen = new Date(date);
  diff = Math.round(Math.abs((datethen.getTime() - datenow.getTime()) / onehour));
  suffix = " hours ago";
  if (diff < 2) {
    suffix = " hour ago";
  }
  if (diff >= 24) {
    diff = Math.round(Math.abs((datethen.getTime() - datenow.getTime()) / oneday));
    suffix = " days ago";
  }
  if (diff < 1) {
    diff = "just now";
    suffix = "";
  }
  return diff + suffix;
};

this.shorten = function(html, maxLength, appendText) {
  var plain, short;
  if (!html) {
    return "";
  }
  html = this.removeH1(html);
  html = this.removeStyle(html);
  plain = this.stripHTML(html);
  if (plain.length < maxLength) {
    return plain;
  }
  short = plain.substr(0, maxLength);
  return short.substr(0, Math.min(short.length, short.lastIndexOf(" "))) + (appendText || "");
};

this.stripHTML = function(html) {
  if (html == null) {
    html = "";
  }
  return html.replace(/(<([^>]+)>)/ig, " ").replace(/ {2}/g, " ").trim();
};

this.dateFormat = function(date) {
  var months;
  if (!(date != null ? date.getDate : void 0)) {
    return '';
  }
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
};

this.removeH1 = function(html) {
  if (html == null) {
    html = "";
  }
  return html.replace(/<h1[^>]*>.+?<\/h1[^>]*>/ig, "");
};

this.removeStyle = function(html) {
  if (html == null) {
    html = "";
  }
  return html.replace(/<style[^>]*>.+?<\/style[^>]*>/ig, "");
};
});
riot.tag2('thermometer-temperatures', '<linechart data="{piedata}" options="{main_chartoptions}" height="300" type="pie"></linechart>', '', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/therm', true);

this.temperatures = {
  "Gold Star": 0,
  "Green Light": 0,
  "Yellow Light": 0,
  "Red Light": 0
};

this.linedata = {
  datasets: []
};

this.piedata = {
  datasets: [],
  labels: []
};

this.main_chartoptions = {
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      boxWidth: 10
    }
  }
};

this.on('mount', (function(_this) {
  return function() {
    return api.get(function(data) {
      return _this.onload(data);
    });
  };
})(this));

this.onload = (function(_this) {
  return function(data) {
    data.comment.forEach(function(comment) {
      return _this.temperatures[comment.temperature_name] += 1;
    });
    _this.piedata.datasets = [
      {
        data: [_this.temperatures["Gold Star"], _this.temperatures["Green Light"], _this.temperatures["Yellow Light"], _this.temperatures["Red Light"]],
        backgroundColor: ['GoldenRod', '#6aca3f', '#fdb32e', '#ca3538']
      }
    ];
    _this.piedata.labels = ["Gold Star", "Green Light", "Yellow Light", "Red Light"];
    return _this.update();
  };
})(this);
});
riot.tag2('thermometer-happiness', '<div if="{opts.chart}" class="happiness-chart"> <linechart data="{piedata}" options="{main_chartoptions}" height="300" type="pie"></linechart> </div> <div if="{!opts.dashboard}"> <div if="{!opts.chart}" class="satisfaction"> <div class="greyblock bg-lightgrey happiness"> <h4>Client<br>satisfaction</h4> <h2 class="green">{happiness}</h2> </div> <p class="text-center">Over {happiness} satisfaction among clients in the last 3 months</p> </div> </div> <div if="{opts.dashboard}"> <div class="dashboard-box"> <h4>Customer Satisfaction</h4> <div class="inner flex"> <div> <h2 class="green text-center">{happiness}</h2> <h3 class="text-center">Over {happiness} satisfaction among clients in the last 3 months</h3> </div> </div> </div> </div>', '', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/therm/happiness', true);

this.happiness = "";

this.happyval = this.sadval = 0;

this.piedata = {
  datasets: [],
  labels: []
};

this.main_chartoptions = {
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      boxWidth: 10
    }
  }
};

this.on('mount', (function(_this) {
  return function() {
    return api.get(function(data) {
      var num;
      _this.happiness = data;
      _this.happyval = parseFloat(_this.happiness);
      _this.sadval = 100 - _this.happyval;
      num = document.querySelector('h2.green');
      if (_this.happyval < 25) {
        num.style.color = '#ca3538';
      }
      if (_this.happyval >= 25 && _this.happyval < 50) {
        num.style.color = '#fdb32e';
      }
      if (_this.happyval >= 50 && _this.happyval < 75) {
        num.style.color = '#6aca3f';
      }
      if (_this.happyval >= 75) {
        num.style.color = '#c0a454';
      }
      _this.piedata.datasets = [
        {
          data: [_this.happyval, _this.sadval],
          backgroundColor: ['#6aca3f', '#ca3538']
        }
      ];
      _this.piedata.labels = ["Happy", "Unhappy"];
      return _this.update();
    });
  };
})(this));
});
riot.tag2('thermometer-temprating', '<div class="wrapper"> <linechart data="{piedata}" options="{main_chartoptions}" width="258" height="280" type="doughnut"></linechart> <div class="percentage {happyclass}">{percent}%</div> <div class="needle"> <div class="np np1"></div> <div class="np np2"></div> <div class="np np3"></div> <div class="np np4"></div> <div class="pin"></div> </div> </div>', 'thermometer-temprating .wrapper { position: relative; } thermometer-temprating .wrapper canvas { margin: 0 auto; } thermometer-temprating .percentage { position: absolute; top: 0; left: 50%; margin-left: -40px; width: 80px; text-align: right; font-size: 30px; font-size: 3rem; font-weight: bold; color: #ca3538; -webkit-transition: color ease 1s; -moz-transition: color ease 1s; -o-transition: color ease 1s; -ms-transition: color ease 1s; transition: color ease 1s; } thermometer-temprating .percentage.yellow { color: #fdb32e; } thermometer-temprating .percentage.green { color: #6aca3f; } thermometer-temprating .percentage.gold { color: #c0a454; } thermometer-temprating .needle { height: 0; width: 120px; position: absolute; bottom: 94px; left: 50%; -webkit-transform-origin: 0 0 0; -moz-transform-origin: 0 0 0; -o-transform-origin: 0 0 0; -ms-transform-origin: 0 0 0; transform-origin: 0 0 0; -webkit-transform: rotate(-180deg); -moz-transform: rotate(-180deg); -o-transform: rotate(-180deg); -ms-transform: rotate(-180deg); transform: rotate(-180deg); -webkit-transition: -webkit-transform ease 3s; -moz-transition: -moz-transform ease 3s; -o-transition: -o-transform ease 3s; -ms-transition: -ms-transform ease 3s; transition: transform ease 3s; } thermometer-temprating .needle .pin { width: 8px; height: 8px; -webkit-border-radius: 100%; border-radius: 100%; background: #fff; position: absolute; left: -4px; top: -4px; } thermometer-temprating .needle .np { position: absolute; width: 0; height: 0; left: 0; top: -8px; } thermometer-temprating .needle .np.np1 { left: -20px; border-bottom: 0px solid transparent; border-left: 0px solid transparent; border-top: 8px solid transparent; border-right: 20px solid #44565e; } thermometer-temprating .needle .np.np2 { left: -20px; top: 0; border-top: 0px solid transparent; border-left: 0px solid transparent; border-bottom: 8px solid transparent; border-right: 20px solid #44565e; } thermometer-temprating .needle .np.np3 { top: 0; border-top: 0px solid transparent; border-right: 0px solid transparent; border-bottom: 8px solid transparent; border-left: 100px solid #44565e; } thermometer-temprating .needle .np.np4 { border-bottom: 0px solid transparent; border-right: 0px solid transparent; border-top: 8px solid transparent; border-left: 100px solid #44565e; }', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/therm/temprating', true);

this.happyclass = "";

this.happyval = 0;

this.percent = 0;

this.rotate = 0;

this.happiness = "";

this.piedata = {
  datasets: [],
  labels: []
};

this.main_chartoptions = {
  tooltips: {
    enabled: false
  },
  responsive: false,
  legend: {
    display: true,
    position: 'bottom',
    labels: {
      boxWidth: 10
    }
  },
  circumference: 1 * Math.PI,
  rotation: -1 * Math.PI
};

this.on('mount', (function(_this) {
  return function() {
    return api.get(function(data) {
      _this.happiness = data;
      _this.happyval = Math.round(parseFloat(_this.happiness));
      setTimeout(function() {
        var duration;
        duration = 2500 / _this.happyval;
        _this.interval = setInterval(function() {
          if (_this.percent < _this.happyval) {
            _this.percent++;
          } else {
            clearInterval(_this.interval);
          }
          if (_this.percent < 25) {
            _this.happyclass = "red";
          }
          if (_this.percent >= 25 && _this.percent < 50) {
            _this.happyclass = "yellow";
          }
          if (_this.percent >= 50 && _this.percent < 75) {
            _this.happyclass = "green";
          }
          if (_this.percent >= 75) {
            _this.happyclass = "gold";
          }
          return _this.update();
        }, duration);
        _this.rotate = -Math.abs(90 - ((90 / 100) * _this.happyval));
        return document.querySelector('.needle').style.transform = "rotate(" + _this.rotate + "deg)";
      }, 1500);
      _this.piedata.datasets = [
        {
          data: [1, 1, 1, 1],
          backgroundColor: ['#ca3538', '#fdb32e', '#6aca3f', 'GoldenRod']
        }
      ];
      _this.piedata.labels = ["0-25", "25-50", "50-75", "75-100"];
      return _this.update();
    });
  };
})(this));
});
riot.tag2('thermometer-responses', '<div class="dashboard-box nomin"> <h4>Responses</h4> <div class="inner"> <linechart data="{bardata}" options="{bar_options}" height="70" type="horizontalBar"></linechart> </div> </div> <div class="dashboard-box nomin"> <h4>Responses</h4> <div class="inner"> <linechart data="{linedata}" options="{main_chartoptions}" height="150" type="line"></linechart> </div> </div>', '', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/therm/responses', true);

this.temperatures = {
  "Gold Star": 0,
  "Green Light": 0,
  "Yellow Light": 0,
  "Red Light": 0
};

this.responses = {
  "Gold Star": [],
  "Green Light": [],
  "Yellow Light": [],
  "Red Light": []
};

this.linedata = {
  datasets: [],
  labels: []
};

this.bardata = {
  data: [],
  labels: ["Excellent", "Good", "Okay", "Poor"]
};

this.main_chartoptions = {
  legend: {
    display: false
  }
};

this.bar_options = {
  legend: {
    display: false
  }
};

this.on('mount', (function(_this) {
  return function() {
    return api.get(function(data) {
      return _this.onload(data);
    });
  };
})(this));

this.onload = (function(_this) {
  return function(data) {
    data.thermometer_blast_response.reverse();
    data.thermometer_blast_response.forEach(function(response) {
      var date, rdate, rday, rmonth, ryear;
      date = new Date(response.response_date);
      date.setHours("00");
      date.setMinutes("00");
      date.setSeconds("00");
      rday = ("0" + (date.getDate().toString())).substr(-2);
      rmonth = ("0" + ((date.getMonth() + 1).toString())).substr(-2);
      ryear = date.getFullYear();
      rdate = rday + "/" + rmonth + "/" + ryear;
      response.rdate = rdate;
      _this.linedata.labels.push(rdate);
      _this.temperatures[response.response] += 1;
      if (!_this.responses[response.response][rdate]) {
        _this.responses[response.response][rdate] = {
          x: '',
          y: 0
        };
      }
      _this.responses[response.response][rdate].y += 1;
      return _this.responses[response.response][rdate].x = rdate;
    });
    _this.bardata.datasets = [
      {
        data: [_this.temperatures["Gold Star"], _this.temperatures["Green Light"], _this.temperatures["Yellow Light"], _this.temperatures["Red Light"]],
        backgroundColor: ['GoldenRod', '#6aca3f', '#fdb32e', '#ca3538'],
        borderColor: '#44565e',
        borderWidth: 1
      }
    ];
    _this.linedata.datasets = [
      {
        label: "Red Light",
        value: "Red Light",
        pointRadius: 0,
        lineTension: 0,
        borderColor: "#44565e",
        borderWidth: 1,
        fill: 'origin',
        backgroundColor: "rgba(202, 53, 56,0.75)",
        data: Object.keys(_this.responses["Red Light"]).map(function(d) {
          return _this.responses["Red Light"][d];
        })
      }, {
        label: "Yellow Light",
        value: "Yellow Light",
        pointRadius: 0,
        lineTension: 0,
        borderColor: "#44565e",
        borderWidth: 1,
        fill: 'origin',
        backgroundColor: "rgba(253, 179, 46,0.75)",
        data: Object.keys(_this.responses["Yellow Light"]).map(function(d) {
          return _this.responses["Yellow Light"][d];
        })
      }, {
        label: "Green Light",
        value: "Green Light",
        pointRadius: 0,
        lineTension: 0,
        borderColor: "#44565e",
        borderWidth: 1,
        fill: 'origin',
        backgroundColor: "rgba(106, 202, 63,0.75)",
        data: Object.keys(_this.responses["Green Light"]).map(function(d) {
          return _this.responses["Green Light"][d];
        })
      }, {
        label: "Gold Star",
        value: "Gold Star",
        pointRadius: 0,
        lineTension: 0,
        borderColor: "#44565e",
        borderWidth: 1,
        fill: 'origin',
        backgroundColor: "GoldenRod",
        data: Object.keys(_this.responses["Gold Star"]).map(function(d) {
          return _this.responses["Gold Star"][d];
        })
      }
    ];
    return _this.update();
  };
})(this);
});
riot.tag2('thermometer-dashboard', '<div class="row"> <div class="col-xs-12"> <hr> </div> </div> <div class="row"> <div class="col-xs-12 col-md-4"> <div class="dashboard-box"> <h4>Satisfaction Ratings</h4> <div class="inner haschart"> <thermometer-temperatures></thermometer-temperatures> </div> </div> </div> <div class="col-xs-12 col-md-4"> <div class="dashboard-box"> <h4>Happiness Factor</h4> <div class="inner haschart"> <thermometer-happiness chart="true"></thermometer-happiness> </div> </div> </div> <div class="col-xs-12 col-md-4"> <div class="dashboard-box"> <h4>Temperature Rating</h4> <div class="inner haschart"> <thermometer-temprating></thermometer-temprating> </div> </div> </div> </div> <div class="row"> <div class="col-xs-12 col-md-6"> <thermometer-comments dashboard="true"></thermometer-comments> </div> <div class="col-xs-12 col-md-6"> <thermometer-happiness dashboard="true"></thermometer-happiness> </div> </div> <div class="row"> <div class="col-xs-12"> <thermometer-responses></thermometer-responses> </div> </div>', '', '', function(opts) {
});
    
  